export default "__VITE_ASSET__8o9V3CCO__"